export enum EstatusAuditoriaEnum {
    PLANEADA = 'PLANEADA',
    EJECUTADA = 'EJECUTADA',
    CANCELADA = 'CANCELADA',
}

export class EstatusAuditoria {
    public static obtenerEnum(valor: string): EstatusAuditoriaEnum {
        switch (valor) {
            case 'PLANEADA': return EstatusAuditoriaEnum.PLANEADA;
            case 'EJECUTADA': return EstatusAuditoriaEnum.EJECUTADA;
            case 'CANCELADA': return EstatusAuditoriaEnum.CANCELADA;
            
        }
        return null;
    }


}
